import { useQuery } from '@tanstack/react-query';
import { SourceType } from '@toggle/toggle';

import { getSubscription } from '~/services/event-alerts/event-alerts-service';

import { QUERY_KEY_EVENT_ALERT_SUBSCRIPTION } from './event-alerts-query-keys';

export const useGetSubscription = (
  sourceId: string,
  sourceType: SourceType,
  enabled = true
) =>
  useQuery({
    queryKey: [QUERY_KEY_EVENT_ALERT_SUBSCRIPTION, sourceId, sourceType],
    queryFn: () => getSubscription(sourceId, sourceType),
    enabled,
  });
